module.exports = __webpack_public_path__ + "img/hero-min.e6996f7a.png";